/* CashMe only accepts mobile numbers in the (xx) 9xxxx-xxxx format, so these
   are stricter than the shared maskTEL, which allows landlines and never caps
   the number of digits. */
export const MOBILE_FORMAT_MESSAGE =
  'Informe um celular válido: (00) 90000-0000';

export function maskMobile(value: string): string {
  const digits = (value ?? '').replace(/\D/g, '').slice(0, 11);

  if (digits.length <= 2) return digits ? `(${digits}` : '';
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function isValidMobile(value: string): boolean {
  const digits = (value ?? '').replace(/\D/g, '');
  return digits.length === 11 && digits[2] === '9';
}
